import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'

const ThinkLoading = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: undefined,
		})

		App.setShowNav(false)
		App.setMainClass("white")

	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding center-cont">
				<i className="icon icon_other_search" style={{ width: "18rem", height: "15.5rem" }} />
				<h3 className="intro-tit mt_30">AI가 고객님의<br />보유종목을 분석하고 있어요...</h3>
			</div>

			<div className="flex-shrink_0 padding">
				<div className="flex-justify_center align_center" style={{ color: "#999" }}>
					*AI분석은 <i className="icon logo_fintech ml_5" /> 와 <i className="icon logo_thinkpool ml_5" /> 이 함께합니다.
				</div>
			</div>
		</div>
	)
}

export default ThinkLoading